import { loadScript } from "../utils/load";

export default function mediaTrust() {
  const src =
    "https://scripts.webcontentassessor.com/scripts/4ca93f8138ee391320844a5f73486804166750feebd4d600d41de59ec8102b3d";
  return loadScript(src);
}
